import { types } from 'mobx-state-tree';
import { api } from 'src/api';
import { createAsync } from 'src/utils/asyncModel';
const getActivityLogsAsync = createAsync(body => {
  return async function getActivityLogs(options) {
    const resp = await api.Activity.getActivityLogs(body, options);
    return resp;
  };
});
const getActivityTypesAsync = createAsync(body => {
  return async function getActivityTypes(options) {
    const resp = await api.Activity.getActivityTypes(body, options);
    return resp;
  };
});
const getBatchAsync = createAsync(batchId => {
  return async function getBatch(options) {
    const resp = await api.Activity.getBatch(batchId, options);
    return resp;
  };
});
const ActivityStore = types.model('ActivityStore', {
  getActivityLogsAsync,
  getActivityTypesAsync,
  getBatchAsync
});
export const activity = types.optional(ActivityStore, {});